const AUDIENCE = 'https://spectrotime-dev.azure-api.net';
const BASEURL = 'https://apim-dev.timelake.io';
const VERSION = 'v1;rev=3';

export const environment = {
  production: false,
  auth0: {
    domain: 'timelake-dev.eu.auth0.com',
    clientId: 'angQuGFM4FsyDlLDllLRSlAiIxK1Z56f',
    audience: AUDIENCE,
    version: VERSION
  },
  apiConfig: {
    oldBaseUrl: 'https://dev-timeter-api.azurewebsites.net',
    baseUrl: `${BASEURL}/${VERSION}`,
    version: `${VERSION}`
  },
  hubConnection: 'https://spectrotime-client-service-dev.azurewebsites.net/hubs/web',
  appInsights: {
    instrumentationKey: 'f4099c9f-86d3-442e-8d32-913c193374c5'
  }
};
